import { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import { failureText } from "../lib/reports.js";

/**
 * Asks before removing something that other people may be using.
 *
 * The sentence says who it affects, because removing a report that was shared is
 * not private: it goes for everyone it was shared with, and nothing here brings
 * it back.
 */
export default function ConfirmDialog({ item, shared, noun = "report", onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const go = async () => {
    setBusy(true);
    setError("");
    try {
      await onConfirm(item);
      onClose();
    } catch (e) {
      setError(failureText(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={Boolean(item)} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth aria-labelledby="confirm-title">
      <DialogTitle id="confirm-title" sx={{ overflowWrap: "anywhere" }}>Remove “{item?.name}”?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">
          {shared
            ? `It is shared, so it goes for everyone it was shared with too, and cannot be brought back.`
            : `It cannot be brought back.`}
          {" "}A {noun}’s earlier versions go with it.
        </Typography>
        {error ? <Alert severity="warning" role="alert" sx={{ mt: 2 }}>{error}</Alert> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Keep it</Button>
        <Button color="error" variant="contained" onClick={go} disabled={busy}>{busy ? "Removing…" : "Remove"}</Button>
      </DialogActions>
    </Dialog>
  );
}
